module.exports = __webpack_public_path__ + "static/media/bn.76f65fc0.svg";